import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useApiWithAuth } from "./useAuth.js";
import { IS_NATIVE_APP } from "../config/appTarget.js";
import { registerPushListeners } from "../lib/push/pushClient.js";

/**
 * Sets up native push-notification listeners once the user is authenticated.
 * Mounted high in the tree (App). Self-guards to native; a no-op on web.
 * The permission PROMPT is triggered contextually from the like flow, not here.
 */
export function usePushNotifications(): void {
  const navigate = useNavigate();
  const { apiCall } = useApiWithAuth();
  const { isAuthenticated } = useAuth0();

  useEffect(() => {
    if (!IS_NATIVE_APP || !isAuthenticated) return;
    void registerPushListeners({ apiCall, navigate });
  }, [isAuthenticated, apiCall, navigate]);
}
